import mitt from "mitt";
const emitter = mitt();

export default function (_ctx, inject) {
  inject("mitt", emitter);
}
